import { useContext } from "react";
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import ErrorContext, { ErrorProvider } from "../shared/ErrorContext";
import Logon from "./Logon";
import { Contact } from "./Contact";
import { Create } from "./Create";
import RecoverPassword from "./RecoverPassword";
import CompleteSignin from "./CompleteSignin";
import StaticHeader from "./components/StaticHeader";
import StaticFooter from "../shared/Footer";
import AuthenticationContext from "../shared/AuthenticationContext";
import ChangePassword from "./ChangePassword";
import logo from "../../assets/logo-default.png";
import "../../styles.css";
import { PasswordExpired } from "./PasswordExpired";
import PageNotFound from "./PageNotFound";
import { isExternalReturnUrl } from "../../utils/authHelpers";
import CompanyService from "../../services/CompanyService";
import { isFeatureEnabled } from "../../utils/featureFlags";
import LogonV2 from "./LogonV2";

export const BodyContainer = (props) => {
  return (
    <div
      className={
        "d-flex flex-column justify-content-center align-items-center flex-grow-1 py-5"
      }
      style={{
        backgroundColor: "var(--intiza-bg)",
        minHeight: "calc(100vh - 179px)"
      }}
    >
      <img
        src={logo}
        alt="intiza"
        width={"150px"}
        height={"auto"}
        className={"d-none mb-3 mt-1"}
      />
      {props.children}
    </div>
  );
};

export const HomeErrorMessage = () => {
  const { currentError } = useContext(ErrorContext);

  return (
    <div
      id="errorMsj"
      className="incorrect"
      style={{
        color: "var(--intiza-variant-danger)",
        fontSize: "14px",
        textAlign: "center",
        margin: "0px 0px 10px"
      }}
      dangerouslySetInnerHTML={{ __html: currentError }}
    />
  );
};

const AuthSite = (props) => {
  const { isAuthenticated } = useContext(AuthenticationContext);
  const isLogonRoute = useRouteMatch("/:lang/logon") !== null;
  const returnUrl = new URLSearchParams(window.location.search).get(
    "returnUrl"
  );
  const isExternalUrl = isExternalReturnUrl(returnUrl);

  // this condition is required for external redirection to CashApp module
  if (isExternalUrl && isAuthenticated) {
    const refreshToken = CompanyService.getCompanyAuth()?.refreshToken;
    window.location.href = `${returnUrl}?token=${refreshToken}`;
    return;
  }

  if (isAuthenticated) {
    return <Redirect to={`/${props.lang}/dashboard`} />;
  }

  if (isLogonRoute && isFeatureEnabled("newLogin")) {
    return (
      <ErrorProvider>
        <div className="logon-v2-page">
          <LogonV2 />
        </div>
      </ErrorProvider>
    );
  }

  return (
    <ErrorProvider>
      <div className="old-page">
        <StaticHeader lang={props.lang} />
        <BodyContainer>
          <div className="pt-5">
            <div className="container logon" id="signin">
              <HomeErrorMessage />
              <Switch>
                <Route path="/:lang/logon" component={Logon} />
                <Route path="/:lang/home/contact" component={Contact} />
                <Route
                  path="/:lang/recoverpassword"
                  component={RecoverPassword}
                />
                <Route
                  path="/:lang/home/recoverpassword"
                  component={RecoverPassword}
                />
                <Route path="/:lang/recover" component={RecoverPassword} />

                <Route
                  path="/:lang/changepassword"
                  component={ChangePassword}
                />
                <Route
                  path="/:lang/account/changepassword"
                  component={ChangePassword}
                />
                <Route
                  path="/:lang/account/passwordexpired"
                  component={PasswordExpired}
                />
                <Route path="/:lang/account/create" component={Create} />
                <Route
                  path="/:lang/account/completesignin"
                  component={CompleteSignin}
                />
                <Route
                  path="/:lang/completesignin"
                  component={CompleteSignin}
                />
                <Route path="/:lang/2af" component={CompleteSignin} />
                <Route path="/:lang/page-not-found" component={PageNotFound} />

                {/* <Redirect to={`/${props.lang}/logon`} /> */}
              </Switch>
            </div>
          </div>
        </BodyContainer>
        <StaticFooter lang={props.lang} />
      </div>
    </ErrorProvider>
  );
};

export default AuthSite;
